import React from 'react';

const HamburgerMenuIcon = ({ className }) => (
  <svg className={className} width="32" height="25" viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="iconPassageShow">
      <g id="Vector">
        <path d="M0 22.5C0 21.3954 0.895431 20.5 2 20.5H19.3333C20.4379 20.5 21.3333 21.3954 21.3333 22.5C21.3333 23.6046 20.4379 24.5 19.3333 24.5H2C0.895433 24.5 0 23.6046 0 22.5Z" fill="currentColor"/>
        <path d="M0 15.8333C0 14.7288 0.895431 13.8333 2 13.8333H30C31.1046 13.8333 32 14.7288 32 15.8333C32 16.9379 31.1046 17.8333 30 17.8333H2C0.895431 17.8333 0 16.9379 0 15.8333Z" fill="currentColor"/>
        <path d="M0 9.16667C0 8.0621 0.895431 7.16667 2 7.16667H30C31.1046 7.16667 32 8.0621 32 9.16667C32 10.2712 31.1046 11.1667 30 11.1667H2C0.895431 11.1667 0 10.2712 0 9.16667Z" fill="currentColor"/>
        <path d="M0 2.5C0 1.39543 0.895431 0.5 2 0.5H30C31.1046 0.5 32 1.39543 32 2.5C32 3.60457 31.1046 4.5 30 4.5H2C0.895431 4.5 0 3.60457 0 2.5Z" fill="currentColor"/>
      </g>
    </g>
  </svg>
);

export default HamburgerMenuIcon;